export const uiRouteConstants = {
 
  backToInternalAdminlUrl: {
    url: environment.base.umbracoUrl + 'internal-administration/'
  },
};
